import { IconWrapper } from '../runtime';
export default IconWrapper('bar-chart', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M1.75 14.2498H14.24M3.05 11.2498H5.95C6.11569 11.2498 6.25 11.1154 6.25 10.9498V4.04976C6.25 3.88407 6.11569 3.74976 5.95 3.74976H3.05C2.88431 3.74976 2.75 3.88407 2.75 4.04976V10.9498C2.75 11.1154 2.88431 11.2498 3.05 11.2498ZM10.05 11.2498H12.95C13.1157 11.2498 13.25 11.1154 13.25 10.9498V2.04976C13.25 1.88407 13.1157 1.74976 12.95 1.74976H10.05C9.88431 1.74976 9.75 1.88407 9.75 2.04976V10.9498C9.75 11.1154 9.88431 11.2498 10.05 11.2498Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});